export interface Contestant {
  id: number;
  name: string;
  tagline: string;
  category: string;
  avatar: string;
  votes: number;
  trend: number;
  momentum: 'up' | 'steady' | 'new';
}

export interface Battle {
  id: number;
  title: string;
  left: Contestant;
  right: Contestant;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const categories = ['全部', '实力唱将', '舞台炸场', '颜值担当', '搞笑担当'];

export const contestants: Contestant[] = [
  {
    id: 1,
    name: '星野夏至',
    tagline: '高音一响 全场起立',
    category: '实力唱将',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20flat%20cartoon%20avatar%20of%20a%20cheerful%20young%20female%20singer%20holding%20a%20microphone%2C%20red%20sparkly%20outfit%2C%20confident%20smile%2C%20solid%20warm%20cream%20background%2C%20modern%20mascot%20style%2C%20clean%20vector%20illustration%2C%20soft%20round%20shapes%2C%20high%20quality&width=400&height=400&seq=avatar-singer-1&orientation=squarish',
    votes: 1285600,
    trend: 12.4,
    momentum: 'up',
  },
  {
    id: 2,
    name: '饼干汽水',
    tagline: '开口就是甜度超标',
    category: '实力唱将',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20flat%20cartoon%20avatar%20of%20a%20sweet%20young%20male%20singer%20wearing%20a%20white%20hoodie%2C%20gentle%20smile%2C%20holding%20a%20guitar%2C%20solid%20soft%20peach%20background%2C%20modern%20mascot%20style%2C%20clean%20vector%20illustration%2C%20soft%20round%20shapes%2C%20high%20quality&width=400&height=400&seq=avatar-singer-2&orientation=squarish',
    votes: 1192000,
    trend: 8.1,
    momentum: 'steady',
  },
  {
    id: 3,
    name: '闪电阿默',
    tagline: '舞台一炸 肾上腺素飙升',
    category: '舞台炸场',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20flat%20cartoon%20avatar%20of%20a%20dynamic%20male%20dancer%20with%20wild%20orange%20hair%20in%20mid-move%2C%20energetic%20pose%2C%20bright%20yellow%20jacket%2C%20solid%20soft%20cream%20background%2C%20modern%20mascot%20style%2C%20clean%20vector%20illustration%2C%20high%20energy%2C%20high%20quality&width=400&height=400&seq=avatar-stage-1&orientation=squarish',
    votes: 1104300,
    trend: 15.8,
    momentum: 'up',
  },
  {
    id: 4,
    name: '桃桃酱',
    tagline: '甜美气场 出圈表情包',
    category: '颜值担当',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20flat%20cartoon%20avatar%20of%20a%20lovely%20young%20girl%20with%20pink%20long%20hair%20winking%20and%20making%20a%20heart%20with%20fingers%2C%20peach%20dress%2C%20solid%20soft%20rose%20background%2C%20modern%20mascot%20style%2C%20clean%20vector%20illustration%2C%20soft%20round%20shapes%2C%20high%20quality&width=400&height=400&seq=avatar-beauty-1&orientation=squarish',
    votes: 987600,
    trend: 5.2,
    momentum: 'steady',
  },
  {
    id: 5,
    name: '咸鱼大侠',
    tagline: '一张嘴 全剧场爆笑',
    category: '搞笑担当',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20flat%20cartoon%20avatar%20of%20a%20funny%20male%20comedian%20with%20big%20round%20glasses%20and%20messy%20hair%2C%20laughing%20loudly%2C%20bright%20teal%20shirt%2C%20solid%20soft%20cream%20background%2C%20modern%20mascot%20style%2C%20clean%20vector%20illustration%2C%20playful%2C%20high%20quality&width=400&height=400&seq=avatar-comedy-1&orientation=squarish',
    votes: 924300,
    trend: 18.9,
    momentum: 'new',
  },
  {
    id: 6,
    name: '喵老师',
    tagline: '温柔声线 唱哭全场',
    category: '实力唱将',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20flat%20cartoon%20avatar%20of%20a%20calm%20female%20singer%20with%20black%20short%20hair%20and%20a%20soft%20smile%20singing%20eyes%20closed%2C%20mint%20dress%2C%20solid%20soft%20cream%20background%2C%20modern%20mascot%20style%2C%20clean%20vector%20illustration%2C%20soft%20warm%20light%2C%20high%20quality&width=400&height=400&seq=avatar-singer-3&orientation=squarish',
    votes: 861200,
    trend: -1.3,
    momentum: 'steady',
  },
  {
    id: 7,
    name: '硬糖kiki',
    tagline: '唱跳全能 拽酷担当',
    category: '舞台炸场',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20flat%20cartoon%20avatar%20of%20a%20cool%20confident%20young%20female%20performer%20with%20purple-ish%20pink%20hair%20and%20a%20denim%20outfit%20striking%20a%20pose%2C%20sunglasses%2C%20solid%20soft%20cream%20background%2C%20modern%20mascot%20style%2C%20clean%20vector%20illustration%2C%20high%20quality&width=400&height=400&seq=avatar-stage-2&orientation=squarish',
    votes: 798500,
    trend: 9.6,
    momentum: 'up',
  },
  {
    id: 8,
    name: '闷油瓶',
    tagline: '沉默反差 开口即王炸',
    category: '搞笑担当',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20flat%20cartoon%20avatar%20of%20a%20deadpan%20young%20man%20with%20short%20black%20hair%20arms%20crossed%20with%20a%20tiny%20smirk%2C%20olive%20green%20shirt%2C%20solid%20soft%20cream%20background%2C%20modern%20mascot%20style%2C%20clean%20vector%20illustration%2C%20funny%2C%20high%20quality&width=400&height=400&seq=avatar-comedy-2&orientation=squarish',
    votes: 693400,
    trend: 22.3,
    momentum: 'new',
  },
];

export const battles: Battle[] = [
  {
    id: 1,
    title: '决赛圈 · 人气之王',
    left: contestants[0],
    right: contestants[1],
  },
  {
    id: 2,
    title: '舞台炸场 · 王者之争',
    left: contestants[2],
    right: contestants[6],
  },
  {
    id: 3,
    title: '快乐源泉 · 笑点PK',
    left: contestants[4],
    right: contestants[7],
  },
];

export const faqs: FaqItem[] = [
  {
    q: '吃瓜大赛的投票打榜规则是什么？',
    a: '每位用户每天都可以为心仪的选手投出多张免费票，只需登录账号即可参与。此外参与站内互动任务（分享、评论、签到）可额外获得助力票，所有票数实时计入人气排行榜，帮助选手冲刺更高名次。',
  },
  {
    q: '人气排行榜多久更新一次？',
    a: '榜单采用实时滚动更新机制，选手获得的每一票都会在几分钟内同步到排行榜与对应PK赛区。你可以在本页直接查看当前票数走势与热门选手的最新排名。',
  },
  {
    q: '如何为自己的选手拉票和助力？',
    a: '点开选手卡片进入投票页，把专属拉票海报与链接分享到朋友圈或粉丝群即可邀请好友来打榜。好友通过你的链接投出的每一票都会计入该选手的人气与个人助力榜。',
  },
  {
    q: '热门PK是怎么产生的？',
    a: '系统会根据各选手当前人气与粉丝活跃度，自动撮合势均力敌的选手进入限时PK赛区。PK结束后人气更高的一方将晋级下一轮，并解锁专属曝光资源位。',
  },
  {
    q: '投票打榜需要付费吗？',
    a: '不需要。投票、签到与互动任务产出的助力票全部免费。请注意，本活动不涉及任何形式的现金充值或抽奖类付费环节，谨防冒充官方人员的私下转账。',
  },
  {
    q: '我支持的选手能进入下一轮吗？',
    a: '能。只要在每轮投票周期结束前帮助选手保持人气排名靠前，就能顺利晋级。建议你设置投票提醒，并持续参与每日互动任务，避免错过关键冲刺时段。',
  },
];